import React, { useEffect, useState, useRef } from 'react';
import styles from 'feature/common/landing/rebate/index.module.scss';
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';
import coin01 from 'images/landing/rebate_coin_01.png';
import coin02 from 'images/landing/rebate_coin_02.png';
import coin03 from 'images/landing/rebate_coin_03.png';
import coin04 from 'images/landing/rebate_coin_04.png';
import { Button } from 'mochi-react-component';
import { Link } from 'react-router-dom';
import { PATHS } from 'config';
import { devicePlateForm } from 'utils/device-util';
import { currentUrl } from 'utils/url-helper';
import analyticsService from 'service/analytics';
import amplitudeService from 'service/amplitude';

const Rebate = () => {
  const { t } = useTranslation();
  const rebateRef = useRef();
  const [coin01Offset, setCoin01Offset] = useState('');
  const [coin02Offset, setCoin02Offset] = useState('');
  const [coin03Offset, setCoin03Offset] = useState('');
  const [coin04Offset, setCoin04Offset] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const start = get(rebateRef, 'current.offsetTop') - window.innerHeight - 400;
      const end = get(rebateRef, 'current.offsetTop') + get(rebateRef, 'current.clientHeight') + 400;
      if (start < window.scrollY && window.scrollY < end) {
        coinMove();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const coinMove = () => {
    const offset = window.scrollY - (get(rebateRef, 'current.offsetTop') - window.innerHeight - 400);
    setCoin01Offset('translate(' + offset * 0.08 + 'px,' + offset * 0.12 + 'px)');
    setCoin02Offset('translate(' + offset * 0.11 + 'px,-' + offset * 0.07 + 'px)');
    setCoin03Offset('translate(-' + offset * 0.07 + 'px,' + offset * 0.15 + 'px)');
    setCoin04Offset('translate(-' + offset * 0.1 + 'px,-' + offset * 0.07 + 'px)');
  };

  const fontSize = () => {
    return devicePlateForm() === 'desktop' ? `14px` : `12px`;
  };

  return (
    <section ref={rebateRef} className={styles.rebate}>
      <div className={styles.coin}>
        <img
          className={styles.coin01}
          src={coin01}
          alt="coin01"
          loading="lazy"
          style={{
            transform: coin01Offset,
          }}
        />
        <img
          className={styles.coin02}
          src={coin02}
          alt="coin02"
          loading="lazy"
          style={{
            transform: coin02Offset,
          }}
        />
        <img
          className={styles.coin03}
          src={coin03}
          alt="coin03"
          loading="lazy"
          style={{
            transform: coin03Offset,
          }}
        />
        <img
          className={styles.coin04}
          src={coin04}
          alt="coin04"
          loading="lazy"
          style={{
            transform: coin04Offset,
          }}
        />
      </div>
      <h2>{t('landing.rebate.title')}</h2>
      <h3>{t('landing.rebate.message')}</h3>
      <Link to={currentUrl(PATHS.PROMOTION)}>
        <Button
          type="solid"
          theme="black"
          onClick={() => {
            analyticsService.track('autopass_refueling_goodnews');
            amplitudeService.track('服務介紹頁-優惠活動_點擊', {
              component: 'card',
            });
          }}
          customStyle={{ fontSize: fontSize() }}
        >
          {t('landing.rebate.promotion')}
        </Button>
      </Link>
    </section>
  );
};

export default Rebate;
